export class ProgressTracker {
  count: number;
  errors: number;
  total: number;

  constructor(total: number) {
    this.count = 0;
    this.errors = 0;
    this.total = total;
  }

  toString(): string {
    const pct = Math.round((10000 * this.count) / this.total) / 100;
    return `${pct}% | ${this.count} / ${this.total} | ${this.errors}`;
  }
}
